import React, { useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { Button } from "@mui/material";
import { TextField } from "@mui/material";
import { Paper } from "@mui/material";
import { Table } from "../../../components/Table";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { disableUser, listUsers } from "../../../services/users";
import { Box } from "@mui/material";
import { Dialog } from "../../../components/Dialog";
import { AddUpdateUser } from "./AddUpdateUser";
import { useToast } from "../../../hooks/useToast";
import { AlertDialog } from "../../../components/AlertDialog";

export function Users() {
  const [data, setData] = useState<any>([]);
  const [mySearch, setMySearch] = useState([]);
  const [control, setControl] = useState(false);
  const [onCloseModal, setOnCloseModal] = useState(false);
  const [typeModal, seTypeModal] = useState({ id: 0, type: "", title: "" });
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [userToDelete, setUserToDelete] = useState(
    {} as { id: number; name: string }
  );

  const queryClient = useQueryClient();
  const toast = useToast();

  const getUsers = useQuery(
    "getUsers",
    async () => {
      const response = await listUsers();
      setData(response.data);
      return response;
    },
    { staleTime: 2000, cacheTime: 10 }
  );

  const disableUserMutation = useMutation(disableUser, {
    onSuccess: async () => {
      toast.show(`${userToDelete.name} foi excluído com sucesso!`, {
        severity: "success",
      });
      await queryClient.invalidateQueries("getUsers");
      setIsOpenModalDelete(false);
    },
  });

  function handleChange(evt: any) {
    console.log(evt.target.value);
    if (evt.target.value !== "") {
      let search: any = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].name.indexOf(evt.target.value) >= 0) {
          search.push(data[i]);
        }
      }
      setMySearch(search);
      if (control === false) {
        setControl((prev) => !prev);
      }
    } else {
      setMySearch([]);
      if (control === true) {
        setControl((prev) => !prev);
      }
    }
  }

  function handleDelete(userId: number) {
    disableUserMutation.mutate(userId);
  }

  function openModal() {
    setOnCloseModal((prev) => !prev);
  }

  const contentModal = () => {
    if (typeModal.type === "add") {
      return (
        <AddUpdateUser
          openModal={openModal}
          type={typeModal.type}
          idUser={-1}
          queryClient={queryClient}
        />
      );
    } else {
      if (typeModal.type === "edt") {
        return (
          <AddUpdateUser
            openModal={openModal}
            type={typeModal.type}
            idUser={typeModal.id}
            queryClient={queryClient}
          />
        );
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item container sx={{ paddingBottom: "1rem" }}>
        <Grid item sx={{ marginRight: "1.5rem" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              seTypeModal({ id: 0, type: "add", title: "Adicionar Usuario" });
              openModal();
            }}
          >
            Adicionar usuario
          </Button>
        </Grid>
        <Grid item>
          <TextField
            size="small"
            name="pesquisar"
            variant="outlined"
            label="Procurar usuário"
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Table
            pageSize={10}
            toolbar={false}
            data={control === false ? data : mySearch }
            isLoading={getUsers.isLoading || !mySearch}
            style={{ border: "none" }}
            headerStyle={{
              backgroundColor: "#F4F3FB",
              color: "#1D1D1D",
              zIndex: 0,
            }}
            onRowClick={(evt: any, selectedRow: any) => {
              if (evt.target.id !== "deleteRow") {
                seTypeModal({id : selectedRow.id, type: 'edt', title: 'Editar usuario'})
                openModal()
              }
            }}    
            columns={[
              {
                title: "Nome",
                field: "name",
                headerStyle: { fontWeight: "600", fontSize: "0.8rem" },
                cellStyle: {
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  color: "#616161",
                },
              },
              {
                title: "",
                field: "",
                align: "center",
              },
              {
                title: "",
                field: "",
                align: "center",
              },
              {
                title: "E-mail",
                field: "email",
                headerStyle: {
                  textAlign: "center",
                  fontWeight: "600",
                  fontSize: "0.8rem",
                },
                cellStyle: {
                  textAlign: "center",
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  color: "#616161",
                },
              },
              {
                title: "",
                field: "",
                align: "center",
              },
              {
                title: "",
                field: "",
                align: "center",
              },
              {
                title: "",
                field: "deleteRow",
                disableClick: true,
                //disableClick: true,
                render: (rowData: { id: number; name: string }) => (
                  <Box
                    sx={{
                      padding: "10px",
                      zIndex: 10,
                      display: "flex",
                      justifyContent: "flex-end",
                      cursor: "pointer",
                    }}
                  >
                    <DeleteOutlineIcon
                      onClick={() => {
                        setUserToDelete(rowData);
                        setIsOpenModalDelete(true);
                      }}
                      id={"deleteRow"}
                      style={{
                        color: "#B02F2F",
                      }}
                    />
                  </Box>
                ),
              },
            ]}
          />
        </Paper>
      </Grid>
      <Dialog
        onClose={() => openModal()}
        fullWidth
        title={typeModal.title}
        maxWidth="md"
        open={onCloseModal}
        children={contentModal()}
      />
      <AlertDialog
        open={isOpenModalDelete}
        loading={disableUserMutation.isLoading}
        contentText="Você realmente deseja deletar este usuário?"
        textAgree={
          disableUserMutation.isLoading ? (
            <CircularProgress sx={{ color: "#FFF" }} size={24} />
          ) : (
            "Sim, deletar"
          )
        }
        textClose={"Cancelar"}
        handleAgree={() => handleDelete(userToDelete.id!)}
        handleClose={() => setIsOpenModalDelete(false)}
      />
    </Grid>
  );
}
